export default {
  loadedBuyer: {},
};
